import { useState } from "react"
import { Textareawithsteroids, Textareawithsteroids2 } from "../ESG/EnvironmentReport"
import { HeaderShow } from "../ESG/ESGmain"

const Step9 = () => {
    const [showContent,setShowContent] = useState(false)
    const subtext = `Build network of peers, within sector and through business community
    
Engage locally and helt others join the quest

Advocate for the policy and financial enablers`

    const actiontext = `Everyone revisits hhow they can partake and support`
    const exercisetext = `Brainstorm on who outside the company you can include in this journey - joint forces are stronger than one, convey how to involve them.`
    return ( 
        <div className="d-flex flex-column align-items-center mt-2">
        <HeaderShow text={"Step 9 Sector and Policy Level"} show={showContent} setShow={()=>setShowContent(!showContent)}/>
        
        
        {
            showContent ?
            <>
            <div className="roleambition__bubble w-90 mt-3 ms-0">
            <h5>{subtext}</h5>
            <div className="d-flex justify-content-between mt-2">
                <div className="d-flex flex-column me-5">
                    <h5 style={{textAlign:"center"}}><b>Action</b></h5>
                    <h5>{actiontext}</h5>
                </div>
                <div className="d-flex flex-column">
                    <h5 style={{textAlign:"center"}}><b>Exercise</b></h5>
                    <h5>{exercisetext}</h5>
                </div>
            </div>
        </div>
            <div className="d-flex align-items-center justify-content-around w-90">
                <div className="sdg__action__exercise">
                    <h4>Action:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step9_action"}
                    />        
                </div>
                <div className="sdg__action__exercise">
                    <h4>Exercise:</h4><Textareawithsteroids2   
                        maxLength={3000}
                        keyHighlight={"step9_exercise"}
                    />        
                </div>
            </div>
            <div className="sdg__action__exercise w-85">
                <h4>Write in your conclusions here:</h4><Textareawithsteroids2   
                    maxLength={3000}
                    keyHighlight={"step9_conclusion"}
                />        
            </div>
            </>:null
        }
        </div>
     );
}
 
export default Step9;